<template>
  <v-card outlined rounded="lg">
    <v-row class="mx-0">
      <v-col cols="12" sm="4" md="4">
        <v-img :src="party?.cover" :aspect-ratio="16 / 9" class="rounded-lg">
          <template v-slot:placeholder>
            <v-skeleton-loader type="image"></v-skeleton-loader>
          </template>
        </v-img>
      </v-col>
      <v-col cols="12" sm="8" md="8">
        <template v-if="!party">
          <v-skeleton-loader type="heading" class="mb-2"></v-skeleton-loader>
          <v-skeleton-loader type="paragraph"></v-skeleton-loader>
          <v-divider class="my-4"></v-divider>
          <v-skeleton-loader type="heading" class="mb-2"></v-skeleton-loader>
          <v-skeleton-loader type="paragraph"></v-skeleton-loader>
        </template>
        <template v-else>
          <h4 class="mb-0">{{ party?.name }}</h4>
          <p>{{ party.date | date("DD [de] MMMM [de] YYYY") }}</p>
          <v-divider class="my-4"></v-divider>
          <h5 class="mb-1">{{ session?.name }}</h5>
          <b class="d-block mb-2">Setores sendo validados</b>
          <div class="d-flex flex-wrap gap-x-3 gap-1">
            <v-chip
              v-for="tg in Object.values(ticketGroups)"
              :key="tg.id"
              color="primary"
              small
            >
              {{ tg.name }} ({{ tg.blocks.length }} lote{{ tg.blocks.length === 1 ? "" : "s" }})
            </v-chip>
          </div>
        </template>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "SessionDetailsCard",
  props: {
    session: {
      type: Object,
    },
  },
  computed: {
    party() {
      return this.session?.Party;
    },
    ticketGroups() {
      if (!this.session?.TicketBlocks) return;
      return this.session?.TicketBlocks.reduce((acc, ticketBlock) => {
        const ticketGroup = ticketBlock.TicketGroup;
        if (!acc[ticketGroup.id])
          acc[ticketGroup.id] = {
            ...ticketGroup,
            blocks: [],
          };
        acc[ticketGroup.id].blocks.push(ticketBlock);
        return acc;
      }, {});
    },
  },
};
</script>
